import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AdminState {
  admin_id: string | null;
  admin_name: string | null;
  token: string | null;
}

// Load initial state from localStorage if available
const loadState = (): AdminState => {
  try {
    const serializedState = localStorage.getItem('adminState');
    if (serializedState === null) {
      return {
        admin_id: null,
        admin_name: null,
        token: null,
      };
    }
    return JSON.parse(serializedState);
  } catch (err) {
    console.warn('Failed to load admin state from localStorage', err);
    return {
      admin_id: null,
      admin_name: null,
      token: null,
    };
  }
};

const initialState: AdminState = loadState();

const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    setAdminData: (
      state,
      action: PayloadAction<{ admin_id: string; admin_name: string; token: string }>
    ) => {
      state.admin_id = action.payload.admin_id;
      state.admin_name = action.payload.admin_name;
      state.token = action.payload.token;
    },
    clearAdminData: (state) => {
      state.admin_id = null;
      state.admin_name = null;
      state.token = null;
    },
  },
});

export const { setAdminData, clearAdminData } = adminSlice.actions;
export default adminSlice.reducer;
